import storage from 'redux-persist/lib/storage'

export default {
  key: 'infowijs-auth',
  storage,
  blacklist: ['iframeReady', 'accessToken', 'error'],
}
